export async function setCameraFOV(
  value: number,
  opts?: { retries?: number; delayMs?: number }
) {
  const retries = opts?.retries ?? 5;
  const delayMs = opts?.delayMs ?? 200;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const w = window as any;
  const containerRef = w?.containerRef;
  const iframeWin = containerRef?.current?.contentWindow;

  if (!iframeWin || typeof iframeWin.SetCameraFOV !== 'function') {
    console.warn('[setCameraFOV] iframe or SetCameraFOV not ready');
    return false;
  }

  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      iframeWin.SetCameraFOV(value);
      return true;
    } catch (e) {
      if (attempt === retries) {
        console.warn('[setCameraFOV] failed after retries', e);
        return false;
      }
      await new Promise(res => setTimeout(res, delayMs));
    }
  }
  return false;
}
